/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import ProjectCard from './ProjectCard';

interface Project {
    id: string;
    name: string;
    description?: string;
    created_at: string;
}

interface ProjectGridProps {
    projects: Project[];
    currentProjectId?: string;
    onSwitch?: (project: Project) => void;
    onEdit: (project: Project) => void;
    onDelete: (project: Project) => void;
}

const ProjectGrid: React.FC<ProjectGridProps> = ({ projects, currentProjectId, onSwitch, onEdit, onDelete }) => {
    return (
        <section
            className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(min(100%,320px),1fr))]"
            aria-label="Projects"
        >
            {projects.map((project) => (
                <ProjectCard
                    key={project.id}
                    project={project}
                    isCurrent={project.id === currentProjectId}
                    onSwitch={onSwitch}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            ))}
        </section>
    );
};

export default ProjectGrid;
